'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'heart';
var width = 512;
var height = 512;
var aliases = [128153,128154,128155,128156,128420,129293,129294,129505,9829,10084,61578];
var unicode = 'f004';
var svgPathData = 'M378.9 48C341.3 48 306 66 284 96.5l-21.5 29.7c-1.5 2.1-3.9 3.3-6.5 3.3s-5-1.2-6.5-3.3L228 96.5c-22-30.5-57.3-48.5-94.9-48.5-64.7 0-117.1 52.4-117.1 117.1 0 60.1 36.9 115.8 75.4 162.7 43.1 52.4 95.4 98 131.2 125.4 9.3 7.1 21 10.8 33.4 10.8s24.1-3.7 33.4-10.8c35.8-27.4 88.1-73 131.2-125.4 38.6-46.9 75.4-102.6 75.4-162.7 0-64.7-52.4-117.1-117.1-117.1zM271 87.1c25-34.6 65.2-55.1 107.9-55.1 73.5 0 133.1 59.6 133.1 133.1 0 66.2-40.4 125.8-79.1 172.8-44.1 53.6-97.3 100.1-133.8 127.9-12.4 9.4-27.6 14.1-43.1 14.1s-30.8-4.6-43.1-14.1C176.4 438 123.2 391.5 79.1 338 40.4 290.9 0 231.3 0 165.1 0 91.6 59.6 32 133.1 32 175.8 32 216 52.5 241 87.1l15 20.7 15-20.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHeart = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;